import { type RouteRecordRaw } from 'vue-router'

export const brandStatusRouter: RouteRecordRaw[] = [
  {
    children: [
      {
        component: async () => import('../views/BrandStatusOverviewView.vue'),
        meta: {
          roles: ['pb:super'],
          title: 'brand-status.overview',
        },
        name: 'brand.brand-status.overview',
        path: 'overview',
      },
    ],
    component: {
      name: 'BrandStatusRouterView',
      template: '<router-view></router-view>',
    },
    meta: {
      roles: ['pb:super'],
    },
    name: 'brand.brand-status',
    path: 'brand-status',
    redirect: { name: 'brand.brand-status.overview' },
  },
]
